import responseStatusActions from '../actions/ResponseStatusActions';

function setLastSaved(state, contentRevisionId, dateStamp) {
    const current = state[contentRevisionId];

    if (!current || current.lastSavedAt < dateStamp) {
        return Object.assign({}, state, { [contentRevisionId]: { lastSavedAt: dateStamp } });
    }

    return state;
}

function setRepliedTo(state, contentRevisionId, repliedTo, allDeclarationsRepliedTo) {
    return Object.assign({}, state, { [contentRevisionId]: { repliedTo, allDeclarationsRepliedTo } });
}

export default function responseStatusReducer(state = {}, action) {
    switch (action.type) {
    case responseStatusActions.types.RESPONSE_STATUS_SET_LAST_SAVED:
        return setLastSaved(state, action.contentRevisionId, action.dateStamp);

    case responseStatusActions.types.RESPONSE_STATUS_SET_REPLIED_TO:
        return setRepliedTo(state, action.contentRevisionId, action.repliedTo, action.allDeclarationsRepliedTo);

    default:
        return state;
    }
}
